import { Component, Input } from '@angular/core';

import { Representante } from '../../representante';

@Component({
    selector: 'sgt-representante-configuracao-meta',
    templateUrl: './representante-configuracao-meta.component.html',
    styleUrls: ['./representante-configuracao-meta.component.less']
})
export class RepresentanteConfiguracaoMetaComponent {
    @Input() entity: Representante;
}
